import { domReady } from "./domReady";

function addPageClass(pageSelector) {
    domReady(() => {
      document.querySelector("html").classList.add(pageSelector);
    }, "html");
  }
export {addPageClass}